import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { Groups2Outlined } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import FlexBetween from "components/FlexBetween";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import { BASEURL } from "api/axiosInstance";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import { fetchListKaryawan } from "state/karyawanActions";
import { fetchDeletePeringatan } from "state/peringatanAction";
import AddJenjangModal from "components/Modals/AddJenjangModal";
import { fetchListJabatan } from "state/jabatanActions";
import { fetchAddJenjang, fetchListJenjang } from "state/jenjangAction";
import SortableHeader from "components/SortableHeader";
import moment from "moment";
import "moment/locale/id";
moment.locale("id");

const Jenjang = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [openAdd, setOpenAdd] = useState(false);
  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  const { status, message } = useSelector((state) => state.global);
  const { list_jenjang } = useSelector((state) => state.jenjang);

  useEffect(() => {
    dispatch(fetchListJenjang());
    dispatch(fetchListKaryawan());
    dispatch(fetchListJabatan());
  }, []);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListJenjang());
  };

  const handleSubmitJenjang = (value) => {
    dispatch(fetchAddJenjang(value));
  };

  const handleSelectedData = (id) => {
    let currentSelectedData = list_jenjang.find((item) => item.id === id);
    setSelectedData(currentSelectedData);
  };
  const handleDelete = () => {
    dispatch(fetchDeletePeringatan(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };

  const columnsPanduan = [
    {
      name: "id", // Kolom UUID
      label: "ID",
      options: {
        display: false, // Disembunyikan dari tampilan tabel
      },
    },
    {
      name: "id_karyawan",
      label: "ID Karyawan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "nama_karyawan",
      label: "Nama Karyawan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "kode_jabatan",
      label: "Kode Jabatan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },

    {
      name: "nama_jabatan",
      label: "Nama Jabatan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },

    {
      name: "tanggal_berlaku",
      label: "Tanggal Berlaku",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => {
          return moment(value).format("DD MMMM YYYY");
        },
      },
    },
    {
      name: "tanggal_berakhir",
      label: "Tanggal Berakhir",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const tipe = tableMeta.rowData[7];
          if (tipe === "Kontrak") {
            return value === null
              ? "Saat Ini"
              : moment(value).format("DD MMMM YYYY");
          } else {
            return "Tidak Tertentu";
          }
        },
      },
    },
    {
      name: "tipe_jenjang",
      label: "Tipe Jenjang",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => {
          return value;
        },
      },
    },
    {
      name: "file_jenjang",
      label: "File Jenjang",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
          />
        ),
        customBodyRender: (value) => {
          if (value) {
            const fileUrl = `${BASEURL}/files/${value}`;
            return (
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", textDecoration: "underline" }}
              >
                File Jenjang
              </a>
            );
          } else {
            return "Tidak Ada";
          }
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    fixedHeader: false,
    fixedSelectColumn: false,
    responsive: "standard",
    rowsPerPageOptions: [30, 60, list_jenjang.length],
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
  };

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header
          title="Jenjang Karyawan"
          subtitle="Daftar Jenjang Karyawan untuk karyawan."
        />

        <Box>
          <Button
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary.light, // Tetap sama dengan warna awal
              },
            }}
            onClick={() => setOpenAdd(true)}
          >
            <Groups2Outlined sx={{ mr: "10px" }} />
            Tambah Jenjang/Mutasi
          </Button>
        </Box>
      </FlexBetween>
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_jenjang}
          columns={columnsPanduan}
          options={options}
        />
        <AddJenjangModal
          open={openAdd}
          onClose={() => setOpenAdd(false)}
          onSubmit={(value) => handleSubmitJenjang(value)}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={"Hapus"}
          subtitleType={"Menghapus"}
          dataWillProses={
            selectedData?.judul_peringatan + " - " + selectedData?.id_karyawan
          }
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => handleDelete()}
        />
      </Box>
    </Box>
  );
};

export default Jenjang;
